// Copyright 2022 Sorama B.V.
import { autoinject, transient } from "aurelia-framework";
import { LicenseKind } from "datatypes/SoramaWebApi";
import { IWorkflowModuleInstance } from "libraries/WorkflowFramework/Interfaces/IWorkflowModule";
import { LicenseRepository } from "repositories/LicenseRepository";

interface ShopifyProduct {
    id: string;
    title: string;
    handle: string;
    description: string;
    published_at: string;
    created_at: string;
    vendor: string;
    type: string;
    tags: string[];
    price: string;
}

@autoinject
@transient()
export class FeatureStoreModule {
    private readonly shopifyScript = "https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js";

    private filterText = "";
    private isFullScreen: boolean;
    private allFeatures = true;
    private allLicenses = [];
    public selectedFeature;
    private moduleInstance: IWorkflowModuleInstance;
    public fullScreenElement: Element;

    private licenseRepository: LicenseRepository;

    constructor(licenseRepository: LicenseRepository) {
        this.licenseRepository = licenseRepository;
    }
    public activateModule(moduleInstance: IWorkflowModuleInstance): void {
        this.moduleInstance = moduleInstance;
    }

    public async attached(): Promise<void> {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const scriptIsLoaded = (window as any).ShopifyBuy && (window as any).ShopifyBuy.UI;

        if (!scriptIsLoaded) {
            await this.loadScript();
        }

        this.initShopifyClient();
    }

    private async loadScript(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            const script = document.createElement("script");
            script.async = true;
            script.src = this.shopifyScript;
            document.getElementsByTagName("body")[0].appendChild(script);
            script.onload = (): void => {
                resolve();
            };
        });
    }

    private async initShopifyClient(): Promise<void> {
        const client = ShopifyBuy.buildClient({
            domain: "sorama-eu.myshopify.com",
            storefrontAccessToken: "eda22c056c913ae4812d19283e29f4f2",
        });

        client.product.fetchAll().then((products) => {
            this.allLicenses = products.filter((product) => product.productType === "FeatureLicense" || true);
        });
    }

    private get filteredPurchasableFeatures(): LicenseKind[] {
        return this.allLicenses.filter((feature) =>
            feature.title.toLowerCase().includes(this.filterText.toLowerCase())
        );
    }

    private showFeatureStoreItem(id: number): void {
        this.allLicenses.forEach((feature) => {
            if (feature.id === id) {
                this.allFeatures = false;
                this.selectedFeature = feature;
            }
        });
    }

    private hideFeatureStoreItem(): void {
        this.allFeatures = !this.allFeatures;
    }
    public toggleFullScreen(): void {
        if (this.isFullScreen) {
            document.exitFullscreen();
        } else if (this.fullScreenElement) {
            this.fullScreenElement.requestFullscreen();
        }
    }
}
